module.exports = __webpack_public_path__ + "7af5a4e1b20a0349096cce854eb5e2b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-pink-s.png
// module id = 2417
// module chunks = 0